import type { DemandPartner } from '../demand/partners/model';
import type { Integration } from '../demand/integrations/model';
import type { Placement } from '../supply/placements/model';
import type { Publisher } from '../supply/publishers/model';
import { SearchEntityKind, type SearchResult } from './model';

export function publisherSearchResult(publisher: Publisher): SearchResult {
  return {
    kind: SearchEntityKind.Publisher,
    id: publisher.id,
    label: publisher.name,
    sublabel: publisher.secondaryId ?? undefined,
    to: '/supply/publishers/$publisherId/details',
    params: { publisherId: publisher.id },
  };
}

export function placementSearchResult(placement: Placement): SearchResult {
  return {
    kind: SearchEntityKind.Placement,
    id: placement.id,
    label: placement.name,
    sublabel: placement.secondaryId ?? undefined,
    to: '/supply/placements/edit/$placementId',
    params: { placementId: placement.id },
  };
}

export function demandPartnerSearchResult(partner: DemandPartner): SearchResult {
  return {
    kind: SearchEntityKind.DemandPartner,
    id: partner.id,
    label: partner.displayName ?? partner.name ?? partner.id,
    sublabel: partner.secondaryId ?? undefined,
    to: '/demand/partners/$demandPartnerId/details',
    params: { demandPartnerId: partner.id },
  };
}

export function integrationSearchResult(integration: Integration): SearchResult {
  return {
    kind: SearchEntityKind.Integration,
    id: integration.id,
    label: integration.name,
    sublabel: integration.demandPartner.displayName ?? integration.demandPartner.name ?? undefined,
    to: '/demand/integrations/$integrationId/demand/$demandPartnerId/details',
    params: { integrationId: integration.id, demandPartnerId: integration.demandPartner.id },
  };
}
